import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BaseNavLink } from '@hdms/shared/page-frame/types';

@Component({
  selector: 'shrd-pf-ui-links-column-wrapper',
  templateUrl: './links-column-wrapper.component.html',
  styleUrls: ['./links-column-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinksColumnWrapperComponent {
  @Input() sectionTitle: string;
  @Input() links: BaseNavLink[];
  @Input() disabled = false;
}
